import React, { useEffect, useState } from 'react';
import FormInput from '../../common/FormInput';
import { PageNames, RoutePaths } from '../../../Constants/Common';
import { ProductType } from '../../common/CommonTypes';
import { useLocation, NavLink } from 'react-router-dom';
import { RepairRequestApi } from '../../../api/RepairRequestApi';
import LoadingContainer from '../../common/loadingContainer/LoadingContainer';
import { GoogleAnalytics } from '../../../classes/GoogleAnalytics';
import PageTitle from '../../common/PageTitle';
import ReloadHandler from '../../common/ReloadHandler';
import { useSelectedVehicle } from '../../hooks/useSelectedVehicle';
import { useAuth0 } from '@auth0/auth0-react';
import { t } from 'i18next';

type LocationState = {
    product: ProductType;
};

const ExistingRepairPage = (): JSX.Element => {
    const { getAccessTokenSilently } = useAuth0();

    useSelectedVehicle(); //this hook redirects back to the landing page if the vehicle is not in the context (i.e. page refresh)

    const location = useLocation();
    const { product } = location.state as LocationState;

    const [loading, setLoading] = useState(false);
    const [repairRequests, setRepairRequests] = useState([]);

    useEffect(() => {
        loadRepairRequests();
        GoogleAnalytics.setPageView(PageNames.PriorRepairRequest);
    }, []);

    const loadRepairRequests = async () => {
        setLoading(true);

        const successCallback = (result) => {
            setRepairRequests(result);
            setLoading(false);
        };

        const failureCallback = () => {
            setLoading(false);
        };

        const token = await getAccessTokenSilently();

        new RepairRequestApi().getRepairRequests(
            product.reference,
            token,
            successCallback,
            failureCallback
        );
    };

    const getFormattedDate = (date: string | number | Date) => {
        const formattedDate = new Date(date).toLocaleString('default', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });

        return formattedDate;
    };

    const renderErrorMessage = () => {
        if (!repairRequests || repairRequests.length < 1) {
            return <p className='error'>{t('no_prior_repair_requests')}</p>;
        }
    };

    return (
        <LoadingContainer loading={loading} message='Loading...'>
            <div className='card page-content'>
                <PageTitle title={t('repair_requests')} />
                <div className='card-body page-content-body'>
                    <FormInput
                        id='repair-forminput'
                        label={`${t('product_reference')}: ${product.reference}`}>
                        {repairRequests.map((repairRequest, index) => (
                            <div
                                id={`repair-request-${index.toString()}`}
                                className='submitted-repair-request'
                                key={index}>
                                <b>{t('repair_reference')}:</b>{' '}
                                {repairRequest.referenceNumber}
                                <br />
                                <b>{t('repair_request_date')}:</b>{' '}
                                {getFormattedDate(repairRequest.created)}
                                <br />
                                <b>{t('status')}:</b> {repairRequest.status}
                                <br />
                                <b>{t('last_updated')}:</b>{' '}
                                {getFormattedDate(repairRequest.lastUpdated)}
                            </div>
                        ))}
                    </FormInput>
                </div>
            </div>
            <div className='bottom-navigation'>
                {renderErrorMessage()}
                <NavLink
                    to={RoutePaths.Home}
                    className='btn btn-secondary progress-button'>
                    {t('back')}
                </NavLink>
            </div>
            <ReloadHandler reloadPath={RoutePaths.LandingPage} />
        </LoadingContainer>
    );
};

export default ExistingRepairPage;
